import React, { useState, useContext } from 'react';
import {
  IconButton,
  Popover,
  FormControlLabel,
  Switch,
  Stack,
  Typography,
  Divider
} from '@mui/material';
import { OutlinedFlag } from '@mui/icons-material';
import FeatureFlagsContext from '../config/FeatureFlagsContext'
import CacheContext from '../cache/CacheContext';
import Cache from '../cache/Cache';

export const FeatureFlagsToggle = () => {
  const featureFlagsContext = useContext(FeatureFlagsContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const cacheContext = useContext(CacheContext)

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'feature-flags-popover' : undefined;

  const clearCache = () => {
    cacheContext.removeAll()
    Cache.removeAll()
  }

  return (
    <>
      {/* The button you put in your control bar */}
      <IconButton
        sx={{color: 'black'}}
        aria-describedby={id}
        onClick={handleOpen}
        size="small"
      >
        <OutlinedFlag sx={{color: 'black'}} />
      </IconButton>

      {/* The flyout menu */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack spacing={1} sx={{ p: 2, minWidth: 220 }}>
          <Typography variant="subtitle1" gutterBottom>
            Feature Flags
          </Typography>
          <Divider />
          {Object.keys(featureFlagsContext.featureFlags).map(flagName => {
            const flagValue = featureFlagsContext.featureFlags[flagName];
            return (
              <FormControlLabel
                key={flagName}
                control={
                  <Switch
                    checked={!!flagValue}
                    onChange={(e) => {
                      clearCache()
                      featureFlagsContext.setFlag(flagName, e.target.checked)
                    }}
                  />
                }
                label={flagName}
              />
            );
          })}
        </Stack>
      </Popover>
    </>
  );
};